<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Charles Coyne was born in Hull, East Riding and educated at Riley High School and Hull Municipal Technical College. After acquiring three degrees, he saw service in the Fleet Air Arm as an Observer. Later, he twice stood as a Member of Parliament and a local government candidate in both Ealing and Leicester. Charles’s career as a management consultant had assignments that took him to Brazil, Venezuela, the USA, and most European countries. During this time, he also produced a number of documents for both the European Commission and the Motor Industry. Now he has retired to the delightful island of Gozo, Malta.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?77b84732